// File: frontend/src/pages/NotFound/NotFound.js
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { useSEO } from '../../contexts/SEOContext';
import SEO from '../../components/SEO/SEO';
import styles from './NotFound.module.css';

const NotFound = () => {
  const { t, language } = useLanguage();
  const { updateSEO } = useSEO();

  useEffect(() => {
    updateSEO({
      title: t('not_found_page_title'),
      description: t('not_found_page_description'),
      noIndex: true, // Don't index 404 pages
      language: language
    });
  }, [updateSEO, t, language]); // Include updateSEO since it's now stable with useCallback

  return (
    <>
      <SEO
        title={t('not_found_page_title')}
        description={t('not_found_page_description')}
        noIndex={true}
        language={language}
      />

      <div className={`${styles.notFoundPage} fade-in`}>
        <div className={styles.container}>
          <div className={styles.errorCode}>404</div>
          <h1 className={styles.errorTitle}>
            {t('not_found_title')}
          </h1>
          <p className={styles.errorDescription}>
            {t('not_found_description')}
          </p>
          
          <Link to="/" className={styles.homeButton}>
            <svg 
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
              <polyline points="9,22 9,12 15,12 15,22" />
            </svg>
            {t('back_to_home')}
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFound;
